export default __webpack_public_path__ + "static/media/icon-phone.04deaa2f.svg";